export default {"name":"NovaComponents-Breadcrumb-gui-icu","comments":[],"messages":{"NovaComponents-Breadcrumb-gui-icu.nav.aria":"Breadcrumb list"}}